import { makeGraphQLPaginatedRequest, makeGraphQLRequest } from 'graphql/makeGraphQLRequest';
import isEmpty from 'lodash/isEmpty';
import {
  GET_DISCOUNT_PERIODS_FOR_ACCOUNT_QUERY,
  FIND_COUPON_CODE_TYPES_QUERY,
  FIND_BUSINESS_DETAILS_QUERY,
  FIND_BRAINTRUST_PLATFORM_CONFIG_QUERY,
} from './partner.gql';

export const getDiscountPeriodsForAccount = async (simplrAccountId) => {
  const result = await makeGraphQLPaginatedRequest(
    GET_DISCOUNT_PERIODS_FOR_ACCOUNT_QUERY,
    {
      filter: {
        simplrAccountId: {
          eq: simplrAccountId,
        },
        status: {
          eq: 'ACTIVE',
        },
        expirationDate: {
          gt: new Date(),
        },
      },
    },
    'discountPeriodsFind'
  );

  return result.data || [];
};

export const fetchCouponCodeTypes = async (simplrAccountId) => {
  const result = await makeGraphQLPaginatedRequest(
    FIND_COUPON_CODE_TYPES_QUERY,
    {
      filter: {
        simplrAccountId: {
          eq: simplrAccountId,
        },
      },
    },
    'couponCodeTypesFind'
  );

  return result.data || [];
};

export const fetchBusinessDetailsPage = async ({
  isAdmin,
  isSpecialistLite,
  whiteList = [],
  page,
  loadLimit,
  searchParam,
  businessStatuses,
  cursor,
  partnersAllowlist,
}) => {
  const paging = {
    first: loadLimit,
    after: cursor,
  };

  const sorting = [
    {
      direction: 'ASC',
      field: 'smbName',
    },
  ];

  const andFilters = [];

  if (isSpecialistLite && !isEmpty(whiteList)) {
    andFilters.push({
      simplrAccountId: {
        in: whiteList,
      },
    });
  } else if (partnersAllowlist.length > 0) {
    andFilters.push({
      simplrAccountId: {
        in: partnersAllowlist,
      },
    });
  } else {
    andFilters.push({
      simplrAccountId: {
        neq: null,
      },
    });
  }

  if (searchParam) {
    // eslint-disable-next-line no-useless-escape
    const matcher = `${searchParam.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')}%`;
    if (matcher) {
      andFilters.push({
        smbName: {
          iLike: matcher,
        },
      });
    }
  }

  if (businessStatuses && businessStatuses.length) {
    andFilters.push({
      accountStatus: {
        in: businessStatuses,
      },
    });
  }

  const filter = {
    and: andFilters,
  };

  const { data: businessDetails, pageInfo } = await makeGraphQLPaginatedRequest(
    FIND_BUSINESS_DETAILS_QUERY,
    {
      paging,
      sorting,
      filter,
      isAdmin,
    },
    'businessDetailsFind'
  );

  return { businessDetails, cursor: pageInfo.cursor };
};

export const fetchBraintrustPlatformConfig = async (simplrAccountId) => {
  const result = await makeGraphQLRequest(
    FIND_BRAINTRUST_PLATFORM_CONFIG_QUERY,
    {
      filter: {
        simplrAccountId: {
          eq: simplrAccountId,
        },
      },
    },
    'platformConfigFindFirst'
  );

  return result;
};
